
import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Maximize2 } from "lucide-react";

interface LyricsPopoutDialogProps {
  title: string;
  value: string;
  onChange?: (value: string) => void;
  readOnly?: boolean;
}

const LyricsPopoutDialog: React.FC<LyricsPopoutDialogProps> = ({
  title,
  value,
  onChange,
  readOnly = false
}) => {
  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button 
          variant="ghost" 
          size="icon" 
          className="absolute top-2 right-2 h-6 w-6 hover:bg-white/10"
        >
          <Maximize2 className="h-4 w-4" />
        </Button>
      </DialogTrigger>
      <DialogContent className="max-w-3xl h-[80vh]">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        <div className="flex-1 min-h-0">
          <Textarea
            value={value}
            onChange={readOnly ? undefined : (e) => onChange?.(e.target.value)}
            readOnly={readOnly}
            className="h-full min-h-[500px] bg-white/5 border-white/10 text-white placeholder:text-white/30 resize-none"
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default LyricsPopoutDialog;
